import { render } from "./ConnectFlowListSort.vue?vue&type=template&id=71504e44&ts=true"
import script from "./ConnectFlowListSort.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConnectFlowListSort.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/connect-flow/components/ConnectFlowListSort.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71504e44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71504e44', __exports__)) {
    api.reload('71504e44', __exports__)
  }
  
  module.hot.accept("./ConnectFlowListSort.vue?vue&type=template&id=71504e44&ts=true", () => {
    api.rerender('71504e44', render)
  })

}


export default __exports__